import { useState, useEffect } from 'react';
import { navigation } from '../../data/mock';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (href) => {
    setIsMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
        isScrolled
          ? 'bg-[#0A0A0A]/95 backdrop-blur-2xl py-3'
          : 'bg-transparent py-6'
      }`}
    >
      <nav className="max-w-[1600px] mx-auto px-6 lg:px-16 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="font-serif text-[28px] tracking-wide text-[#F5F1EC] hover:opacity-70 transition-opacity duration-300 bg-transparent border-none cursor-pointer"
          style={{ textShadow: '0 1px 12px rgba(0,0,0,0.5)' }}
        >
          <span className="font-light tracking-wider">ALL THE</span>{' '}
          <span className="font-semibold italic text-[#C4A265]">Details</span>
        </button>

        <div className="hidden md:flex items-center gap-10">
          {navigation.map((item) => (
            <button
              key={item.label}
              onClick={() => scrollTo(item.href)}
              className="text-[#8A8580] hover:text-[#F5F1EC] text-[12px] tracking-[0.25em] uppercase transition-colors duration-300 bg-transparent border-none cursor-pointer"
            >
              {item.label}
            </button>
          ))}
        </div>

        <button
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          className="md:hidden text-[#F5F1EC] bg-transparent border-none cursor-pointer"
        >
          {isMobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      <div
        className={`md:hidden overflow-hidden transition-all duration-500 ${
          isMobileOpen ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-[#0A0A0A]/98 backdrop-blur-2xl border-t border-white/[0.04] px-6 py-6 flex flex-col gap-5">
          {navigation.map((item) => (
            <button
              key={item.label}
              onClick={() => scrollTo(item.href)}
              className="text-[#8A8580] hover:text-[#F5F1EC] text-[12px] tracking-[0.25em] uppercase text-left bg-transparent border-none cursor-pointer transition-colors duration-300"
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
};
